const CURRENCY_INPUT_DEFAULTS = Object.freeze({
  currency: null,
  precision: 0,
  locale: "en-US",
  allowNegative: false
});
export {
  CURRENCY_INPUT_DEFAULTS
};
